import { Lock } from 'lucide-react';

export const PremiumGate = ({ isPremium, onUpgrade, children, featureName }) => {
  if (isPremium) return children;

  return (
    <div className="relative">
      {/* Blurred/dimmed preview */}
      <div className="pointer-events-none select-none opacity-30 blur-[2px]">
        {children}
      </div>

      {/* Lock overlay */}
      <div className="absolute inset-0 flex flex-col items-center justify-center bg-black/70 border-2 border-yellow-500 p-4">
        <Lock size={28} className="text-yellow-400 mb-2" />
        <p className="text-yellow-400 font-black text-sm uppercase tracking-wider text-center mb-3">
          {featureName} — SendIt Pass Required
        </p>
        <button
          onClick={onUpgrade}
          className="bg-yellow-500 hover:bg-yellow-400 text-black font-black text-sm uppercase tracking-widest px-5 py-2 border-2 border-yellow-300 transition-all active:scale-95 touch-manipulation"
          style={{ boxShadow: '0 0 16px rgba(234,179,8,0.5)' }}
        >
          GET SENDIT PASS
        </button>
      </div>
    </div>
  );
};
